export default __webpack_public_path__ + "static/media/shimmeringinvocation.9200b12d.png";